import { render, staticRenderFns } from "./128.vue?vue&type=template&id=51313433&scoped=true&"
var script = {}
import style0 from "./128.vue?vue&type=style&index=0&id=51313433&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51313433",
  null
  
)

export default component.exports